//noinspection JSValidateTypes
export default angular.module("propertyFilter", [])
  .filter("property", propertyFilter)
  .name;

const $inject = [];

function propertyFilter() {
  return function (items, properties) {
    if (!angular.isArray(items)) {
      return items;
    }
    else {
      return items.filter(item => Object.entries(properties).some(
        ([key, search_text]) => (item[key] === null? "": item[key]).toString().toLowerCase().includes(search_text.toLowerCase())
      ));
    }
  };
}

propertyFilter.$inject = $inject;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/filters/property.filter.js
 **/